import { Link } from "react-router-dom";
import LastUpdated from "./LastUpdated";

export default function InfographicHeader({ dataset }) {
  return (
    <header className="bg-neutral-950 py-14 text-white sm:py-20">
      <div className="site-shell">
        <div className="flex flex-wrap items-center gap-3">
          <span className="rounded-full border border-blue-400/40 bg-blue-500/10 px-3 py-1.5 text-xs font-black uppercase tracking-[0.18em] text-blue-200">{dataset.category}</span>
        </div>
        <h1 className="mt-5 max-w-5xl text-4xl font-black tracking-tight sm:text-6xl">{dataset.title}</h1>
        <p className="mt-5 max-w-4xl text-lg leading-8 text-neutral-300">{dataset.directAnswer}</p>
        <div className="mt-7 flex flex-wrap items-center gap-4">
          <LastUpdated date={dataset.lastUpdated} />
          {dataset.dataAsOf && <span className="text-sm text-neutral-300">Source observations through {dataset.dataAsOf}. Analysis revised separately.</span>}
          <Link to="/robotics/humanoid-robot-data" className="font-bold text-blue-300 hover:text-white">Open all humanoid data charts</Link>
        </div>
      </div>
    </header>
  );
}
